export default __webpack_public_path__ + "static/media/98-15_header_invoice.97363b1a.png";